import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';

import SceneChangerLink from './SceneChanger/components/SceneChangerLink';

class LinkFade extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    sceneChangerStore: PropTypes.object.isRequired,
  };

  runAnimation = () => {
    return new Promise(resolve => {
      setTimeout(() => resolve({ type: 'common' }), 150);
    });
  };

  render() {
    const { to, children, ...rest } = this.props;

    return (
      <SceneChangerLink to={to} runAnimation={this.runAnimation} {...rest} innerRef={node => (this.node = node)}>
        {children}
      </SceneChangerLink>
    );
  }
}

export default inject(stores => ({
  sceneChangerStore: stores.store.sceneChanger,
}))(LinkFade);



// WEBPACK FOOTER //
// ./src/components/LinkFade.js